import React from "react"

const Process = () => {

  return (
    <section className="py-10 md:py-14 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-semibold text-[#4A4A4A]">
            Lab Tests Delivered to <span className="text-[#951C25]">Your Doorstep</span>
          </h2>
          <p className="text-[#4A4A4A]/70 mt-2">
            Trusted by <span className="font-medium">40 Lakhs+</span> satisfied customers |{" "}
            <span className="font-medium">1 Crore+</span> lab tests booked
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 border border-[#E0E0E0]">
          {/* Home */}
          <div className="flex flex-col items-center text-center border-b border-r md:border-b-0 md:border-r border-[#E0E0E0] p-4">
            <div className="w-24 h-24 flex items-center justify-center mb-3">
              <img src="/images/delivery.png" alt="Test Tube Sample" />
            </div>
            <h3 className="text-base font-medium text-[#4A4A4A] mb-1">Home</h3>
            <p className="text-xs text-[#4A4A4A]/70">Sample Pick Up</p>
          </div>

          {/* View */}
          <div className="flex flex-col items-center text-center border-b md:border-b-0 md:border-r border-[#E0E0E0] p-4">
            <div className="w-24 h-24 flex items-center justify-center mb-3">
              <img src="/images/reports.png" alt="View Reports Online" />
            </div>
            <h3 className="text-base font-medium text-[#4A4A4A] mb-1">View</h3>
            <p className="text-xs text-[#4A4A4A]/70">Reports Online</p>
          </div>

          {/* 100% Safe */}
          <div className="flex flex-col items-center text-center border-r md:border-r border-t md:border-t-0 border-[#E0E0E0] p-4">
            <div className="w-24 h-24 flex items-center justify-center mb-3">
              <img src="/images/safty.png" alt="Medical Safety Shield" />
            </div>
            <h3 className="text-base font-medium text-[#4A4A4A] mb-1">100% Safe</h3>
            <p className="text-xs text-[#4A4A4A]/70">& Hygienic</p>
          </div>

          {/* Best Prices */}
          <div className="flex flex-col items-center text-center border-t md:border-t-0 border-[#E0E0E0] p-4">
            <div className="w-24 h-24 flex items-center justify-center mb-3">
              <img src="/images/best_price.png" alt="Discount Badge" />
            </div>
            <h3 className="text-base font-medium text-[#4A4A4A] mb-1">Best Prices</h3>
            <p className="text-xs text-[#4A4A4A]/70">Guaranteed</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Process
